'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getPricingData;

var _price = require('dibs-selectors/dist/price');

var priceSelectors = _interopRequireWildcard(_price);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function getPricingData(_ref) {
    var salePrice = _ref.salePrice,
        retailPrice = _ref.retailPrice,
        netPrice = _ref.netPrice;

    var retailPriceAmountUSD = priceSelectors.getPriceAmountByCurrency(retailPrice)('USD');
    var pricingHideRetail = priceSelectors.isPriceHidden(retailPrice);
    var pricingHideNet = netPrice ? priceSelectors.isPriceHidden(netPrice) : true;

    var pricingShowSale = void 0;
    if (salePrice) {
        var salePriceAmountUSD = priceSelectors.getPriceAmountByCurrency(salePrice)('USD');
        pricingShowSale = salePriceAmountUSD > 0 && salePriceAmountUSD < retailPriceAmountUSD;
    } else {
        pricingShowSale = false;
    }

    var pricingValidNet = void 0;
    if (netPrice && !pricingHideNet) {
        var netPriceAmountUSD = priceSelectors.getPriceAmountByCurrency(netPrice)('USD');
        pricingValidNet = netPriceAmountUSD > 0;
        if (retailPriceAmountUSD) {
            pricingValidNet = pricingValidNet && netPriceAmountUSD < retailPriceAmountUSD;
        } else if (!pricingHideRetail) {
            throw new Error('Retail price must have convertedAmounts if it is not hidden');
        }
    } else {
        pricingValidNet = false;
    }

    return {
        pricingShowSale: pricingShowSale,
        pricingValidNet: pricingValidNet,
        pricingHideRetail: pricingHideRetail,
        pricingNegotiableSale: priceSelectors.isNegotiable(salePrice),
        pricingNegotiableRetail: priceSelectors.isNegotiable(retailPrice)
    };
}


//////////////////
// WEBPACK FOOTER
// ./~/dibs-display-helpers/dist/utils/getPricingData.js
// module id = 1242
// module chunks = 64